<div
	class="row trafficLight"
	matTooltip="{{
		'mep.components.homescreen.' + (isGreen() ? 'green' : isYellow() ? 'yellow' : isRed() ? 'red' : 'grey') | translate
	}}"
>
	<div class="light" [ngClass]="isGreen() ? 'green' : 'grey'"></div>
	<div class="light" [ngClass]="isYellow() ? 'yellow' : 'grey'"></div>
	<div class="light" [ngClass]="isRed() ? 'red' : 'grey'"></div>
</div>
